/**
 * @author vishwadeep.kapoor
 * @Date: 2020-12-11 20:59:31
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-11 23:01:37
 */

import React from 'react';
import { Row, Col } from 'antd';
import { shape } from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import endPoints from '../../../config/endPoints';
import { AppWrappperHOC } from '../../Root/HOC';
import AboutTimeline from './Timeline';
import AboutsMap from '../ContactUS/Map';
import Journey from '../../../containers/NewLanding/Journey';
import LandingAwards from '../../../containers/NewLanding/Awards';
import { constants } from '../../../devUtils';
import { HelmetWrapper, LandingContainer, SubTitle } from '../../../components';

const StyledAboutUs = styled.section`
  .grayscale-filter{
    filter: grayscale(100%);
  }
  h1{
    font-family: 'Mulish',sans-serif;
    color: ${({ theme }) => theme.LandingBlack};
  }
  p{
    color: ${({ theme }) => theme.LandingBlack};
  }
  .landing{
    padding: 60px 0px;
    position: relative;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      padding: 0px 0px;
      height:auto;
    };
  }
  .vision-mission{
    background-color: ${({ theme }) => theme.webGray};
    .side-heading{
      display: flex;
      align-items: baseline;
    }
  }
  .about-us{
    .gray-box{
      background: ${({ theme }) => theme.tintGray};
      padding: 20px;
      border-radius: 10px;
      height: 150px;
    }
    .white-box{
      background: ${({ theme }) => theme.whiteColor};
      box-shadow: 3px 3px 20px #24415D0F;
      padding: 20px;
      border-radius: 10px;
      height: 150px;
    }
  }
  .about-us-values{
    background-color: ${({ theme }) => theme.webGray};
    .grey-bg{
      background: ${({ theme }) => theme.webGray};
      padding: 40px;
      border-radius: 10px;
      height: 200px;
    }
    .whit-bg{
      background: ${({ theme }) => theme.lightWhite};
      padding: 40px;
      border-radius: 10px;
      height: 200px;
    }
  }
  .company-growth{
    .title{
      font-weight: bold;
      span{
        background: ${({ theme }) => theme.primaryColor};
        padding: 3px 10px;
        color: ${({ theme }) => theme.whiteColor};
        border-radius: 4px;
        font-size: 40px;
      }
    }
  }
`;

function AboutUS(props) {
  const { location } = props;
  return (
    <StyledAboutUs>
      <HelmetWrapper location={location} />
      <div className="gray-greadient">
        <section className="landing">
          <LandingContainer>
            <Row align="top" type="flex" justify="start" gutter={32}>
              <Col xs={24} sm={24} md={24} lg={10} xl={10} className="padding-t-3">
                <p>Company</p>
                <h1>About Us</h1>
                <p>
                  Zaggle builds world-class financial solutions and products to manage the business expenses of corporates, SMEs, & Startups through automated and innovative workflows.
                </p>
                <Link to={constants.LINK_CAREERS} className="btn red-btn margin-t-1">Join Zaggle Team</Link>
              </Col>
              <Col xs={24} sm={24} md={24} lg={14} xl={14}>
                <img
                  src={endPoints.ABOUT_US_LANDING.URL}
                  alt={endPoints.ABOUT_US_LANDING.ALT}
                  className="width-100 grayscale-filter"
                />
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="about-us padding-b-6">
          <LandingContainer>
            <Row align="top" type="flex" justify="start" gutter={32}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <SubTitle fontWeight="900" className="font-22">About Us</SubTitle>
                <p>
          Incorporated in 2011, we operate in a segment where we interact and interface with our Customers (i.e., businesses)
and end Users (i.e., employees) and are among a small number of uniquely positioned players with a diversified
offering of fintech products and services, having one of the largest number of issued prepaid cards in India in
partnership with certain of our banking partners (which constituted approximately 16.0% of India’s total prepaid
transaction volume, as of March 31, 2023), a diversified portfolio of SaaS, including tax and payroll software, and a
wide touchpoint reach (Source: Frost & Sullivan Report). We are a leading player in spend management, with more
than 50 million prepaid cards issued in partnership with banking partners and more than 2.27 million users served, as
of March 31, 2023. We offer a differentiated value proposition and diversified user base (Source: Frost & Sullivan
Report).
                </p>
                <p>
          We are sector-agnostic, and our network of corporate customers (“Customers”) covers the banking and finance,
technology, healthcare, manufacturing, FMCG, infrastructure and automobile industries, among others, where we
have relationships with brands such as TATA Steel, Persistent Systems, Vitech, Inox, Pitney Bowes, Wockhardt,
MAZDA, PCBL (RP – Sanjiv Goenka Group), Hiranandani group, Cotiviti and Greenply Industries.
                </p>
                <p>
          We are placed at the intersection of the SaaS and fintech ecosystems, and our SaaS platform is designed for: (i)
business spend management (including expense management and vendor management); (ii) rewards and incentives
management for employees and channel partners; and (iii) gift card management for merchants, which we refer to as
customer engagement management system (“CEMS”). Our core product portfolio include:
                </p>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} className="nopadding">
                  <div className="gray-box text-center">
                    <img
                      src={endPoints.ZAGGLE_DETAILS_CORPORATE_CILENTS_ICON.URL}
                      alt={endPoints.ZAGGLE_DETAILS_CORPORATE_CILENTS_ICON.ALT}
                    />
                    <SubTitle fontWeight="900" className="nomargin font-24">2,411&#43;</SubTitle>
                    <h3 className="nomargin font-16">Customers</h3>
                  </div>
                  <div className="white-box text-center">
                    <img
                      src={endPoints.ZAGGLE_DETAILS_MILLION_USERS_ICON.URL}
                      alt={endPoints.ZAGGLE_DETAILS_MILLION_USERS_ICON.ALT}
                    />
                    <SubTitle fontWeight="900" className="nomargin font-24">2.2 <span className="font-14">Million&#43;</span></SubTitle>
                    <h3 className="nomargin font-16">Users</h3>
                  </div>
                  <div className="gray-box text-center">
                    <img
                      src={endPoints.ZAGGLE_DETAILS_OFFICES_ICON.URL}
                      alt={endPoints.ZAGGLE_DETAILS_OFFICES_ICON.ALT}
                    />
                    <SubTitle fontWeight="900" className="nomargin font-24">6</SubTitle>
                    <h3 className="nomargin font-16">Offices</h3>
                  </div>
                  <div className="white-box text-center">
                    <img
                      src={endPoints.ZAGGLE_DETAILS_NETWORK_PARTNERS_ICON.URL}
                      alt={endPoints.ZAGGLE_DETAILS_NETWORK_PARTNERS_ICON.ALT}
                    />
                    <SubTitle fontWeight="900" className="nomargin font-24">2</SubTitle>
                    <h3 className="nomargin font-16">Network Partners</h3>
                  </div>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12} className="nopadding">
                  <div className="white-box text-center">
                    <img
                      src={endPoints.ZAGGLE_DETAILS_MILLION_GIFTCARDS_ICON.URL}
                      alt={endPoints.ZAGGLE_DETAILS_MILLION_GIFTCARDS_ICON.ALT}
                    />
                    <SubTitle fontWeight="900" className="nomargin font-24">50 <span className="font-14">Million</span></SubTitle>
                    <h3 className="nomargin font-16">Prepaid cards since inception</h3>
                  </div>
                  <div className="gray-box text-center">
                    <img
                      src={endPoints.ZAGGLE_DETAILS_EMPLOYEES_ICON.URL}
                      alt={endPoints.ZAGGLE_DETAILS_EMPLOYEES_ICON.ALT}
                    />
                    <SubTitle fontWeight="900" className="nomargin font-24">250&#43;</SubTitle>
                    <h3 className="nomargin font-16">Employees</h3>
                  </div>
                  <div className="white-box text-center">
                    <img
                      src={endPoints.ZAGGLE_DETAILS_BANKING_PARTNERS_ICON.URL}
                      alt={endPoints.ZAGGLE_DETAILS_BANKING_PARTNERS_ICON.ALT}
                    />
                    <SubTitle fontWeight="900" className="nomargin font-24">3</SubTitle>
                    <h3 className="nomargin font-16">Banking Partners</h3>
                  </div>
                </Col>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <p className="padding-t-3 padding-b-1">
                  <ul className="no-margin">
                    <li className="padding-t-1">
                      <strong>"Propel"</strong>, a corporate SaaS platform for channel rewards and incentives, employee rewards and recognition;
                    </li>
                    <li className="padding-t-1">
                      <strong>"Save"</strong>, a SaaS-based platform and a mobile application to offer expense management solution for business spend management facilitating digitised employee reimbursements and tax benefits;
                    </li>
                    <li className="padding-t-1">
                      <strong>"CEMS"</strong>, a customer engagement management system that enables merchants to comprehensively manage their
customer experiences including rewarding merchants through gift card and loyalty benefits;
                    </li>
                    <li className="padding-t-1">
                      <strong>"Zaggle Payroll Card"</strong>, a prepaid payroll card that allows our Customers to pay contractors, consultants, seasonal
and temporary employees, and unbanked wage workers as an alternative to direct deposits to bank accounts or
cash payments; and
                    </li>
                    <li className="padding-t-1">
                      <strong>"Zoyer"</strong>, an integrated data driven, SaaS based business spend management platform with embedded automated
finance capabilities in core invoice to pay workflows.
                    </li>
                  </ul>
                </p>
                <p>
                We offer an ecosystem-based approach across SaaS and fintech, with low customer acquisition and retention costs in
the business-to-business (“B2B”) segment. Our approach revolves around cross-selling, up-selling, and offering our
products and services in partnership with other players in the operating ecosystems. Through our arrangements with
partner banks and fintechs, our Customers are able to offer their employees, channel partners and consumers a suite
of SaaS and fintech solutions. We offer an integrated value proposition through our SaaS platform, providing a
combination of payment instruments as well as an integrated mobile application that digitises business and employee
spends. Application programming interface (“API”) integrations on the platforms provided to our Customers offer
them enhanced convenience and an efficient user experience through a simplified dashboard. This enables a clear,
distinct and integrated access to our products, and gives us an opportunity to promote and offer our third-party
associations through the same dashboard. Our ability to offer diversified SaaS offerings to an existing customer base
enables us to launch new products and cross-sell products to our wide User base. Accordingly, we have partnered
with, and have entered into arrangements with, DBS Bank, Fibe (formerly, EarlySalary) and Tata Securities to offer
their products and value-added services (“VAS”), including insurance, investment and tax planning, to our Users on
our platform.
                </p>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="vision-mission padding-tb-4">
          <LandingContainer>
            <Row align="top" type="flex" justify="start" gutter={32}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <div className="side-heading">
                  <img
                    src={endPoints.ABOUT_US_VISION_IMAGE.URL}
                    alt={endPoints.ABOUT_US_VISION_IMAGE.ALT}
                  />
                  <SubTitle fontWeight="900" className="margin-l-1 font-22"> Mission</SubTitle>
                </div>
                <p>To build state of art financial solutions workflow and products which would help automate and empower businesses to increase efficiency, accuracy, transparency, and productivity and which would eventually help India achieve the goal of becoming a digital economy.</p>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="padding-t-5">
          <LandingContainer>
            <SubTitle fontWeight="900" className="font-24">Our Story</SubTitle>
            <Row align="top" type="flex" justify="center" gutter={32}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <p className="padding-b-2">
                  The journey started in the year 2011 and the first thing which comes to mind post vision is Team.
                </p>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <img src={endPoints.ABOUT_US_GROUP_IMAGE_TWO.URL} alt={endPoints.ABOUT_US_GROUP_IMAGE_TWO.ALT} className="width-100 grayscale-filter" />
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <AboutTimeline />
        <section className="padding-b-5">
          <LandingAwards />
        </section>
        <section className="padding-b-5 company-growth">
          <LandingContainer>
            <Row align="top" type="flex" justify="start" gutter={32}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h2 className="title">
                  Over the last <span>9</span> Years,
                </h2>
                <h2 className="font-20">We have grown to a team size of <b>250+</b> employees serving our customers through various offices across India</h2>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <p className="padding-tb-1">
                  We built the company initially focussing on corporate customers and giving them financial instruments like prepaid cards to be used for rewards, incentives. This gave us an entry into the corporates and we started understanding how the channel distribution and sales processes were built and how we could sell more products to them.
                </p>
                <p className="padding-b-1">
                  During the journey, we realized that our focus on technology helped us a lot in converting prospects to clients by giving them a better understanding of their spends which led to better utilization of money.
                </p>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <p className="padding-tb-1">
                  This gave us an understanding of various corporates’ processes and workflows and we realized that they were facing tremendous issues related to business and employee expenditure and timely filing of paperwork and bills clearance.
                </p>
                <p className="padding-b-1">
                  Expense management is a challenge to both employers and employees as maintaining and reconciling the employee expenses cost more than the expenses themselves. The manual paper-work drains the energy of employees and reduces productivity and efficiency.
                </p>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center padding-tb-2">
                <img src={endPoints.ABOUT_US_GROUP_ONE_IMAGE.URL} alt={endPoints.ABOUT_US_GROUP_IMAGE_TWO.ALT} className="width-9 grayscale-filter" />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <p className="padding-tb-1">
                  We spent about 12 months, spoke to 100’s of corporates, and realized that it’s a big issue which leaves the employees and suppliers dissatisfied and unmotivated. We started working on it with a module-based approach and as of now, we have implemented the expense management system in hundreds of companies. While we continue to build more use cases to cover the entire process around the expense category.
                </p>
                <p className="padding-b-1">
                  As we are building the expense management system into a robust corporate-wide process implementation, we realized some difficulties which they are facing especially while paying to employees on a contract, or one-time business expenditure. We worked on creating a different payment channel for these ad hoc payments and launched a business credit card to fulfill the requirement and just in time payments as we keep fulfilling more use-cases for the credit card.
                </p>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <p className="padding-tb-1">
                  Business-to-business (B2B) payables is estimated to be a US$2 trillion opportunity in India. Today a significant proportion of spend is entrenched in paper-laden, manual and complex processes, which hamstrings ability of finance, procurement, technology teams to effectively manage operating cash flows. We  launched Zoyer to simplify and automate business to business payments for Enterprises and SMEs. Zoyer unites accounts payable and credit card payments onto a single platform to enable enterprises streamline business to business payables for effectively managing operating cash flows and maximizing business performance. A cloud-native platform, Zoyer improves efficiencies by automating the complete accounts payable lifecycle including supplier on-boarding, PO issuance, invoice capture, three-way reconciliation, payments and advanced reporting.
                </p>
                <p className="padding-tb-1">
                  We will keep- updating our story as it unfolds and hope that you join us to make it a memorable one.
                </p>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="padding-tb-5 about-us-values">
          <LandingContainer>
            <Row align="top" type="flex" justify="start">
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <SubTitle fontWeight="900" className="font-22">Our Values</SubTitle>
                <p>Our core values lie in uplifting the customer’s experience through simple and efficient products</p>
              </Col>
              <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <div className="whit-bg">
                    <SubTitle fontWeight="900" className="font-20">Innovation</SubTitle>
                    <p>Innovation is at our core. We walk an extra mile to create innovative products for users</p>
                  </div>
                  <div className="grey-bg">
                    <SubTitle fontWeight="900" className="font-20">Customer-Centric</SubTitle>
                    <p>We are customer-obsessed and they are the basic foundation for us</p>
                  </div>
                  <div className="whit-bg">
                    <SubTitle fontWeight="900" className="font-20">Excellence</SubTitle>
                    <p>We believe in excellence as a way of life and quality is our highest priority</p>
                  </div>
                  <div className="grey-bg">
                    <SubTitle fontWeight="900" className="font-20">Empathy</SubTitle>
                    <p>We have walked through a whole user experience to design top-notch products to address their issues</p>
                  </div>
                  <div className="whit-bg">
                    <SubTitle fontWeight="900" className="font-20">Security</SubTitle>
                    <p>We maintain high-security standards for all our customer’s data and information</p>
                  </div>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <div className="grey-bg">
                    <SubTitle fontWeight="900" className="font-20">Sustainability</SubTitle>
                    <p>We are dedicated to build a sustainable future for the Fintech industry and bring in a positive impact among the people</p>
                  </div>
                  <div className="whit-bg">
                    <SubTitle fontWeight="900" className="font-20">Reliability</SubTitle>
                    <p>We are consistent in delivering the most reliable products for our customers</p>
                  </div>
                  <div className="grey-bg">
                    <SubTitle fontWeight="900" className="font-20">Transparency</SubTitle>
                    <p>We are committed to maintaining two-way and open communication with users</p>
                  </div>
                  <div className="whit-bg">
                    <SubTitle fontWeight="900" className="font-18">Continuous Improvement:</SubTitle>
                    <p>We work relentlessly to improve and remain at the cutting edge of technology</p>
                  </div>
                </Col>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <AboutsMap />
        <Journey />
      </div>
    </StyledAboutUs>
  );
}

AboutUS.propTypes = {
  location: shape({}).isRequired,
};

const component = AppWrappperHOC(AboutUS);

export { AboutUS };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/AboutUS/index.js